import { Typography } from "@material-ui/core";
import { InfoItem } from "../contacts/WatchContactPage";


export default function CapexAndOpex({ project }) {
    const capexOpex = project?.capexOpex;

    const CapexAndOpex = () => {

        return (
            <>
                <div className="d-flex align-item-center mt-5 flex-column">
                    <Typography variant="h6" color="text.secondary">
                        Capex and Opex
                    </Typography>
                </div>
                <div className="d-flex align-item-center">
                    <div className="col-4">
                        <InfoItem label="CAPEX -EPC estimated price: " value={capexOpex?.capexPrice !== undefined ? capexOpex?.capexPrice + ' €k/MW' : '---'} h6 row />
                    </div>
                    <div className="col-4">
                        <InfoItem label="We offer EPC Services: " value={capexOpex?.capexService ? 'Yes' : 'No'} h6 row />
                    </div>
                </div>
                <div className="d-flex align-item-center">
                    <div className="col-4">
                        <InfoItem label="OPEX: " value={capexOpex?.opexPrice !== undefined ? capexOpex?.opexPrice + ' €k/MW' : '---'} h6 row />
                    </div>
                    <div className="col-4">
                        <InfoItem label="We offer O&M Services: " value={capexOpex?.opexServices ? 'Yes' : 'No'} h6 row />
                    </div>
                </div>
            </>
        )
    }


    const Manufacturers = () => {
        const manufacturers = project?.manufacturers;
        return (
            <>
                <div className="d-flex align-item-center mt-5 flex-column">
                    <Typography variant="h6" color="text.secondary">
                        Manufacturers
                    </Typography>
                </div>
                <div className="d-flex align-item-center">
                    <div className="col-4">
                        <InfoItem label="Modules" value={manufacturers?.modules?.fullName} />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Turbine " value={manufacturers?.turbine?.fullName} />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Battery " value={manufacturers?.battery?.fullName} />
                    </div>
                </div>
                <div className="d-flex align-item-center">
                    <div className="col-4">
                        <InfoItem label="Electrolyzer " value={manufacturers?.electrolyzer?.fullName} />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Inverter " value={manufacturers?.inverter?.fullName} />
                    </div>
                </div>
                <div className="d-flex align-item-center">
                    <div className="col-8">
                        <InfoItem label="Observations" value={manufacturers?.observationManu} h6 />
                    </div>
                </div>


            </>
        )
    }

    return (
        <>
            <CapexAndOpex />
            <Manufacturers />
        </>
    )
}